import ParameterFieldBase from '../../../../_common/platform/ts/ParameterFieldBase';
import EditComponent, { IChartConstantLinesField_inThemesOptions } from './ChartConstantLinesField_inThemes';

export class ChartConstantLinesField_inThemes extends ParameterFieldBase<IChartConstantLinesField_inThemesOptions> {
    public static EditComponent = EditComponent;
    public static getDefaultValue() {
        return [];
    }

    constructor(
        glob,
        title: string,
        validators?: any,
        defaultVal?: any,
        options?: IChartConstantLinesField_inThemesOptions
    ) {
        if (defaultVal == null) {
            defaultVal = ChartConstantLinesField_inThemes.getDefaultValue();
        }

        super(glob, title, [], validators, defaultVal, options);
    }
}
